import { Stack } from "@mui/material";
import React from "react";
import { useFlags } from "launchdarkly-react-client-sdk";

import { DIALOG_HELPER_TEXTS } from "./AccountEditorConsts";
import HyroField from "@hyro-components/fields/HyroField";
import { FIELD_TYPES } from "@hyro-components/fields/utils";

const validateAccountName = (value) => {
  const regexp = /^(?! )+[a-zA-Z0-9 ]*(?<! )$/i;
  const matches = value.match(regexp);
  return value.length && matches ? "" : DIALOG_HELPER_TEXTS.accountName;
};

const validateAccountId = (value) => {
  const regexp = /^(?! )+[a-z0-9]+(?:-[a-z0-9]+)*(?<! )$/i;
  const matches = value.match(regexp);
  return value.length && matches ? "" : DIALOG_HELPER_TEXTS.accountId;
};

const AccountEditorFields = ({ data, onChange, type, timezoneOptions }) => {
  const { enableUpdateTimezone } = useFlags();

  return (
    <Stack gap={2} my={3}>
      <HyroField
        onChange={(value) => onChange({ target: { value, name: "name" } }, validateAccountName)}
        value={data?.name.value}
        data-testid='create-account-input-name'
        name="name"
        label="Account name"
        error={!!data?.name.errorText}
        helperText={data?.name.errorText || " "}
        showTopSection
        fullWidth
      />

      {type === "edit" && (
        <>
          <HyroField
            onChange={(value) => onChange({ target: { value, name: "accountId" } }, validateAccountId)}
            value={data?.accountId.value}
            data-testid='create-account-input-id'
            name="accountId"
            label="Account Id"
            error={!!data?.accountId.errorText}
            helperText={data?.accountId.errorText || " "}
            showTopSection
            fullWidth
          />
          {enableUpdateTimezone && (
            <HyroField
              fieldType={FIELD_TYPES.CHOOSE_ONE}
              onChange={(value) => onChange({ target: { value, name: "timezone" } })}
              value={data?.timezone?.value}
              data-testid='account-timezone-select'
              name="timezone"
              label="Time zone"
              description="Default for all agents in this account. Time zones can be overridden per agent in its settings."
              options={timezoneOptions}
              showTopSection
              fullWidth
            />
          )}
        </>
      )}
    </Stack>
  );
};

export default AccountEditorFields;
